import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "space-y-6"
}
const _hoisted_2 = { class: "p-6 rounded-2xl bg-gradient-to-r from-gray-50 via-white to-gray-50 dark:from-gray-800/80 dark:via-gray-800 dark:to-gray-800/80 border border-gray-200 dark:border-gray-700 shadow-sm flex flex-col sm:flex-row items-center sm:items-start gap-6" }
const _hoisted_3 = { class: "flex-shrink-0" }
const _hoisted_4 = { class: "h-24 w-24 rounded-full bg-secondary/10 dark:bg-secondary-dark/20 text-secondary dark:text-secondary-dark-text flex items-center justify-center overflow-hidden ring-4 ring-white dark:ring-gray-700 shadow-md border-2 border-gray-200 dark:border-gray-600" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 1,
  class: "text-3xl font-bold tracking-tight"
}
const _hoisted_7 = { class: "flex-1 text-center sm:text-left min-w-0" }
const _hoisted_8 = { class: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2" }
const _hoisted_9 = { class: "text-2xl font-bold text-gray-900 dark:text-white truncate" }
const _hoisted_10 = { class: "text-sm font-medium text-secondary dark:text-secondary-dark-text mt-0.5" }
const _hoisted_11 = {
  key: 0,
  class: "text-gray-400 dark:text-gray-500"
}
const _hoisted_12 = { class: "inline-flex items-center gap-2 self-center sm:self-start" }
const _hoisted_13 = { class: "mt-4 flex flex-wrap items-center justify-center sm:justify-start gap-3 text-xs text-gray-600 dark:text-gray-300" }
const _hoisted_14 = { class: "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-gray-100 dark:bg-gray-700/60 font-medium" }
const _hoisted_15 = {
  key: 0,
  class: "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-gray-100 dark:bg-gray-700/60 font-medium"
}
const _hoisted_16 = { class: "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-purple-50 text-purple-700 dark:bg-purple-950/40 dark:text-purple-300 font-semibold border border-purple-200 dark:border-purple-800" }
const _hoisted_17 = ["title"]
const _hoisted_18 = {
  key: 4,
  class: "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-gray-100 text-gray-600 dark:bg-gray-700/60 dark:text-gray-300 font-medium border border-gray-200 dark:border-gray-700",
  title: "Staff account created directly via Register Staff"
}
const _hoisted_19 = { class: "border-b border-gray-200 dark:border-gray-700 pb-2" }
const _hoisted_20 = {
  class: "flex flex-wrap items-center gap-1.5 sm:gap-2",
  "aria-label": "Tabs"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "space-y-4" }
const _hoisted_23 = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4" }
const _hoisted_24 = { class: "p-4 rounded-xl bg-gray-50 dark:bg-gray-800/50 border border-gray-100 dark:border-gray-700/60" }
const _hoisted_25 = { class: "p-4 rounded-xl bg-gray-50 dark:bg-gray-800/50 border border-gray-100 dark:border-gray-700/60" }
const _hoisted_26 = { class: "p-4 rounded-xl bg-gray-50 dark:bg-gray-800/50 border border-gray-100 dark:border-gray-700/60" }
const _hoisted_27 = { class: "p-4 rounded-xl bg-gray-50 dark:bg-gray-800/50 border border-gray-100 dark:border-gray-700/60" }
const _hoisted_28 = { class: "p-4 rounded-xl bg-gray-50 dark:bg-gray-800/50 border border-gray-100 dark:border-gray-700/60" }
const _hoisted_29 = { class: "p-4 rounded-xl bg-gray-50 dark:bg-gray-800/50 border border-gray-100 dark:border-gray-700/60" }
const _hoisted_30 = { class: "space-y-4" }
const _hoisted_31 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4" }
const _hoisted_32 = { class: "p-4 rounded-xl bg-gray-50 dark:bg-gray-800/50 border border-gray-100 dark:border-gray-700/60" }
const _hoisted_33 = { class: "p-4 rounded-xl bg-gray-50 dark:bg-gray-800/50 border border-gray-100 dark:border-gray-700/60" }
const _hoisted_34 = { class: "p-4 rounded-xl bg-gray-50 dark:bg-gray-800/50 border border-gray-100 dark:border-gray-700/60 space-y-3" }
const _hoisted_35 = { class: "flex items-center gap-2" }
const _hoisted_36 = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 pt-1" }
const _hoisted_37 = { class: "sm:col-span-2" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "space-y-4" }
const _hoisted_40 = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4" }
const _hoisted_41 = { class: "p-4 rounded-xl bg-gray-50 dark:bg-gray-800/50 border border-gray-100 dark:border-gray-700/60" }
const _hoisted_42 = { class: "text-base font-semibold text-gray-900 dark:text-white mt-1" }
const _hoisted_43 = { class: "p-4 rounded-xl bg-gray-50 dark:bg-gray-800/50 border border-gray-100 dark:border-gray-700/60" }
const _hoisted_44 = { class: "text-base font-semibold text-gray-900 dark:text-white mt-1" }
const _hoisted_45 = { class: "p-4 rounded-xl bg-gray-50 dark:bg-gray-800/50 border border-gray-100 dark:border-gray-700/60" }
const _hoisted_46 = { class: "text-base font-semibold text-gray-900 dark:text-white mt-1" }
const _hoisted_47 = { class: "p-4 rounded-xl bg-gray-50 dark:bg-gray-800/50 border border-gray-100 dark:border-gray-700/60" }
const _hoisted_48 = { class: "text-base font-semibold text-gray-900 dark:text-white mt-1 capitalize" }
const _hoisted_49 = { class: "p-4 rounded-xl bg-gray-50 dark:bg-gray-800/50 border border-gray-100 dark:border-gray-700/60" }
const _hoisted_50 = { class: "text-base font-semibold text-gray-900 dark:text-white mt-1" }
const _hoisted_51 = { class: "p-4 rounded-xl bg-gray-50 dark:bg-gray-800/50 border border-gray-100 dark:border-gray-700/60" }
const _hoisted_52 = { class: "text-base font-semibold text-gray-900 dark:text-white mt-1" }
const _hoisted_53 = { class: "p-4 rounded-xl bg-gray-50 dark:bg-gray-800/50 border border-gray-100 dark:border-gray-700/60" }
const _hoisted_54 = { class: "mt-1 flex items-center gap-2" }
const _hoisted_55 = {
  key: 1,
  class: "text-base font-semibold text-gray-400 dark:text-gray-500 italic"
}
const _hoisted_56 = { class: "p-4 rounded-xl bg-gray-50 dark:bg-gray-800/50 border border-gray-100 dark:border-gray-700/60" }
const _hoisted_57 = { class: "mt-1 flex items-center gap-2" }
const _hoisted_58 = {
  key: 1,
  class: "text-base font-semibold text-gray-400 dark:text-gray-500 italic"
}
const _hoisted_59 = { class: "space-y-4" }
const _hoisted_60 = { class: "p-5 rounded-2xl bg-amber-50/50 dark:bg-amber-950/20 border border-amber-200/70 dark:border-amber-900/40" }
const _hoisted_61 = { class: "flex items-center gap-2 mb-4" }
const _hoisted_62 = { class: "grid grid-cols-1 sm:grid-cols-3 gap-4" }
const _hoisted_63 = { class: "p-4 rounded-xl bg-white dark:bg-gray-800 border border-amber-100 dark:border-gray-700" }
const _hoisted_64 = { class: "text-base font-semibold text-gray-900 dark:text-white mt-1" }
const _hoisted_65 = { class: "p-4 rounded-xl bg-white dark:bg-gray-800 border border-amber-100 dark:border-gray-700" }
const _hoisted_66 = { class: "text-base font-semibold text-gray-900 dark:text-white mt-1" }
const _hoisted_67 = { class: "p-4 rounded-xl bg-white dark:bg-gray-800 border border-amber-100 dark:border-gray-700" }
const _hoisted_68 = { class: "text-base font-semibold text-gray-900 dark:text-white mt-1" }
const _hoisted_69 = { class: "space-y-4" }
const _hoisted_70 = { class: "p-6 rounded-2xl bg-gray-50 dark:bg-gray-800/40 border border-gray-200 dark:border-gray-700 text-center space-y-4" }
const _hoisted_71 = { class: "w-14 h-14 mx-auto rounded-2xl bg-secondary/10 dark:bg-secondary-dark/20 text-secondary dark:text-secondary-dark-text flex items-center justify-center" }
const _hoisted_72 = { class: "flex flex-wrap justify-center gap-3 pt-2" }
const _hoisted_73 = { class: "flex items-center justify-between w-full" }
const _hoisted_74 = { class: "flex items-center gap-2" }
const _hoisted_75 = { class: "flex items-center gap-2" }

import { ref, computed, watch } from 'vue'
import BaseModal from '@/components/common/BaseModal.vue'
import BaseButton from '@/components/common/BaseButton.vue'
import type { employee } from '@/types/employee'
import {
  UserCircle,
  Mail,
  Phone,
  MapPin,
  FileCheck,
  User,
  UserPlus,
  Briefcase,
  AlertTriangle,
  Files,
  FolderOpen,
  UploadCloud,
  FileText,
  Edit3,
  Users,
} from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'ViewStaffProfile',
  props: {
    isVisible: { type: Boolean },
    employee: {}
  },
  emits: ["close", "edit", "manageDocuments", "uploadDocuments", "view-application"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const activeTab = ref('personal')
const imageErrored = ref(false)

watch(() => props.employee, () => {
  imageErrored.value = false
})

const initials = computed(() => {
  if (!props.employee) return 'ST'
  const first = props.employee.first_name?.charAt(0) || ''
  const last = props.employee.last_name?.charAt(0) || ''
  return (first + last).toUpperCase() || 'ST'
})

const tabs = computed(() => [
  { id: 'personal', label: 'Personal Info', icon: User },
  { id: 'contact', label: 'Contact & Address', icon: MapPin },
  { id: 'employment', label: 'Employment', icon: Briefcase },
  { id: 'emergency', label: 'Emergency Contact', icon: AlertTriangle },
  { 
    id: 'documents', 
    label: 'Documents', 
    icon: Files,
    badge: props.employee?.total_documents ?? 0
  },
])

const valueClass = (value?: string | null) => {
  return value ? 'text-gray-900 dark:text-white' : 'text-gray-500 dark:text-gray-400'
}

const formatDate = (dateStr?: string | null) => {
  if (!dateStr) return 'Not Provided'
  try {
    const d = new Date(dateStr)
    if (isNaN(d.getTime())) return dateStr
    return d.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    })
  } catch {
    return dateStr
  }
}

const closeModal = () => {
  emit('close')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    "is-visible": _ctx.isVisible,
    title: "Staff Profile",
    subtitle: _ctx.employee ? `${_ctx.employee.first_name} ${_ctx.employee.last_name}'s full profile & records` : 'Staff profile details',
    icon: _unref(UserCircle),
    size: "4xl",
    type: "default",
    "show-footer": true,
    onClose: closeModal
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_73, [
        _createElementVNode("div", _hoisted_74, [
          _createVNode(BaseButton, {
            text: "Documents",
            variant: "outline",
            size: "sm",
            icon: _unref(FileText),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('manageDocuments', _ctx.employee)))
          }, null, 8, ["icon"]),
          _createVNode(BaseButton, {
            text: "Upload Files",
            variant: "ghost",
            size: "sm",
            icon: _unref(UploadCloud),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('uploadDocuments', _ctx.employee)))
          }, null, 8, ["icon"]),
          (_ctx.employee.has_application && _ctx.employee.application_id)
            ? (_openBlock(), _createBlock(BaseButton, {
                key: 0,
                text: "View Application",
                variant: "outline",
                size: "sm",
                icon: _unref(FileCheck),
                class: "text-emerald-700 border-emerald-300 hover:bg-emerald-50 dark:text-emerald-300 dark:border-emerald-700 dark:hover:bg-emerald-950/40",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('view-application', _ctx.employee)))
              }, null, 8, ["icon"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_75, [
          _createVNode(BaseButton, {
            text: "Edit Profile",
            variant: "secondary",
            size: "sm",
            icon: _unref(Edit3),
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('edit', _ctx.employee)))
          }, null, 8, ["icon"]),
          _createVNode(BaseButton, {
            text: "Close",
            variant: "primary",
            size: "sm",
            onClick: closeModal
          })
        ])
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.employee)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (_ctx.employee.user_image && !imageErrored.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.employee.user_image,
                        alt: _ctx.employee.full_name,
                        class: "h-full w-full object-cover rounded-full",
                        onError: _cache[0] || (_cache[0] = ($event: any) => (imageErrored.value = true))
                      }, null, 40, _hoisted_5))
                    : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(initials.value), 1))
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.employee.first_name) + " " + _toDisplayString(_ctx.employee.middle_name ? _ctx.employee.middle_name + ' ' : '') + _toDisplayString(_ctx.employee.last_name), 1),
                    _createElementVNode("p", _hoisted_10, [
                      _createTextVNode(_toDisplayString(_ctx.employee.position || 'Staff Member') + " ", 1),
                      (_ctx.employee.department)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, " • " + _toDisplayString(_ctx.employee.department), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", {
                      class: _normalizeClass([
                  'px-3 py-1 text-xs font-semibold rounded-full border',
                  _ctx.employee.status === 'Active'
                    ? 'bg-green-50 text-green-700 border-green-200 dark:bg-green-950/40 dark:text-green-400 dark:border-green-800'
                    : 'bg-red-50 text-red-700 border-red-200 dark:bg-red-950/40 dark:text-red-400 dark:border-red-800'
                ])
                    }, _toDisplayString(_ctx.employee.status), 3)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, [
                    _createVNode(_unref(Mail), { class: "w-3.5 h-3.5 text-gray-400" }),
                    _createTextVNode(" " + _toDisplayString(_ctx.employee.email), 1)
                  ]),
                  (_ctx.employee.phone_number)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                        _createVNode(_unref(Phone), { class: "w-3.5 h-3.5 text-gray-400" }),
                        _createTextVNode(" " + _toDisplayString(_ctx.employee.phone_number), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_16, [
                    _createVNode(_unref(FileCheck), { class: "w-3.5 h-3.5 text-purple-500" }),
                    _createTextVNode(" " + _toDisplayString(_ctx.employee.total_documents || 0) + " Documents on File ", 1)
                  ]),
                  (_ctx.employee.work_state)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: _normalizeClass(["inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg font-semibold border", [
                _ctx.employee.work_state === 'Maryland'
                  ? 'bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950/40 dark:text-blue-300 dark:border-blue-800'
                  : _ctx.employee.work_state === 'DC'
                  ? 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-800'
                  : 'bg-indigo-50 text-indigo-700 border-indigo-200 dark:bg-indigo-950/40 dark:text-indigo-300 dark:border-indigo-800'
              ]])
                      }, [
                        _createVNode(_unref(MapPin), { class: "w-3.5 h-3.5" }),
                        _createElementVNode("span", null, "State: " + _toDisplayString(_ctx.employee.work_state === 'Both' ? 'MD & DC' : _ctx.employee.work_state), 1)
                      ], 2))
                    : _createCommentVNode("", true),
                  (_ctx.employee.service_population)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 2,
                        class: _normalizeClass(["inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg font-semibold border", [
                _ctx.employee.service_population === 'Adults'
                  ? 'bg-amber-50 text-amber-800 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-800'
                  : _ctx.employee.service_population === 'Kids'
                  ? 'bg-pink-50 text-pink-700 border-pink-200 dark:bg-pink-950/40 dark:text-pink-300 dark:border-pink-800'
                  : 'bg-teal-50 text-teal-700 border-teal-200 dark:bg-teal-950/40 dark:text-teal-300 dark:border-teal-800'
              ]])
                      }, [
                        _createVNode(_unref(Users), { class: "w-3.5 h-3.5" }),
                        _createElementVNode("span", null, "Clients: " + _toDisplayString(_ctx.employee.service_population === 'Both' ? 'Adults & Kids' : _ctx.employee.service_population), 1)
                      ], 2))
                    : _createCommentVNode("", true),
                  (_ctx.employee.has_application && _ctx.employee.application_id)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('view-application', _ctx.employee))),
                        class: "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-emerald-50 text-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-300 font-semibold border border-emerald-200 dark:border-emerald-800 hover:bg-emerald-100 dark:hover:bg-emerald-900/60 transition cursor-pointer",
                        title: `Approved via Application System (App #${_ctx.employee.application_id}) - Click to view full application details`
                      }, [
                        _createVNode(_unref(FileCheck), { class: "w-3.5 h-3.5 text-emerald-600 dark:text-emerald-400" }),
                        _createElementVNode("span", null, "System Approved Applicant (App #" + _toDisplayString(_ctx.employee.application_id) + ")", 1)
                      ], 8, _hoisted_17))
                    : (_openBlock(), _createElementBlock("span", _hoisted_18, [
                        _createVNode(_unref(UserPlus), { class: "w-3.5 h-3.5 text-gray-500" }),
                        _cache[8] || (_cache[8] = _createElementVNode("span", null, "Direct Registration", -1))
                      ]))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("nav", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: tab.id,
                    type: "button",
                    onClick: ($event: any) => (activeTab.value = tab.id),
                    class: _normalizeClass([
              'px-3 sm:px-3.5 py-1.5 sm:py-2 text-xs sm:text-sm font-semibold rounded-xl transition-all duration-150 flex items-center gap-2',
              activeTab.value === tab.id
                ? 'bg-secondary text-white shadow-sm'
                : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800'
            ])
                  }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(tab.icon), { class: "w-4 h-4 flex-shrink-0" })),
                    _createElementVNode("span", null, _toDisplayString(tab.label), 1),
                    (tab.badge !== undefined)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass([
                'px-1.5 py-0.5 text-[10px] rounded-full font-bold',
                activeTab.value === tab.id
                  ? 'bg-white/20 text-white'
                  : 'bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-300'
              ])
                        }, _toDisplayString(tab.badge), 3))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_21))
                }), 128))
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400" }, "First Name", -1)),
                  _createElementVNode("p", {
                    class: _normalizeClass(['text-base font-semibold mt-1', valueClass(_ctx.employee.first_name)])
                  }, _toDisplayString(_ctx.employee.first_name || 'Not Provided'), 3)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400" }, "Middle Name", -1)),
                  _createElementVNode("p", {
                    class: _normalizeClass(['text-base font-semibold mt-1', valueClass(_ctx.employee.middle_name)])
                  }, _toDisplayString(_ctx.employee.middle_name || 'Not Specified'), 3)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400" }, "Last Name", -1)),
                  _createElementVNode("p", {
                    class: _normalizeClass(['text-base font-semibold mt-1', valueClass(_ctx.employee.last_name)])
                  }, _toDisplayString(_ctx.employee.last_name || 'Not Provided'), 3)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400" }, "Date of Birth", -1)),
                  _createElementVNode("p", {
                    class: _normalizeClass(['text-base font-semibold mt-1', valueClass(_ctx.employee.date_of_birth)])
                  }, _toDisplayString(formatDate(_ctx.employee.date_of_birth)), 3)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _cache[13] || (_cache[13] = _createElementVNode("span", { class: "text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400" }, "Gender", -1)),
                  _createElementVNode("p", {
                    class: _normalizeClass(['text-base font-semibold mt-1', valueClass(_ctx.employee.gender)])
                  }, _toDisplayString(_ctx.employee.gender || 'Not Specified'), 3)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400" }, "SSN (Last 4)", -1)),
                  _createElementVNode("p", {
                    class: _normalizeClass(['text-base font-semibold mt-1', valueClass(_ctx.employee.ssn_last_four)])
                  }, _toDisplayString(_ctx.employee.ssn_last_four ? `***-**-${_ctx.employee.ssn_last_four}` : 'Not Provided'), 3)
                ])
              ])
            ], 512), [
              [_vShow, activeTab.value === 'personal']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400" }, "Email Address", -1)),
                  _createElementVNode("p", {
                    class: _normalizeClass(['text-base font-semibold mt-1 break-all', valueClass(_ctx.employee.email)])
                  }, _toDisplayString(_ctx.employee.email || 'Not Provided'), 3)
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400" }, "Phone Number", -1)),
                  _createElementVNode("p", {
                    class: _normalizeClass(['text-base font-semibold mt-1', valueClass(_ctx.employee.phone_number)])
                  }, _toDisplayString(_ctx.employee.phone_number || 'Not Provided'), 3)
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_unref(MapPin), { class: "w-4 h-4 text-secondary dark:text-secondary-dark-text" }),
                  _cache[17] || (_cache[17] = _createElementVNode("h4", { class: "text-sm font-bold uppercase tracking-wider text-gray-700 dark:text-gray-200" }, "Residential Address", -1))
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-xs font-medium text-gray-500 dark:text-gray-400" }, "STREET ADDRESS", -1)),
                    _createElementVNode("p", {
                      class: _normalizeClass(['text-sm font-semibold mt-0.5', valueClass(_ctx.employee.street_address)])
                    }, _toDisplayString(_ctx.employee.street_address || 'Not Provided'), 3)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-xs font-medium text-gray-500 dark:text-gray-400" }, "CITY", -1)),
                    _createElementVNode("p", {
                      class: _normalizeClass(['text-sm font-semibold mt-0.5', valueClass(_ctx.employee.city)])
                    }, _toDisplayString(_ctx.employee.city || 'Not Provided'), 3)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[20] || (_cache[20] = _createElementVNode("span", { class: "text-xs font-medium text-gray-500 dark:text-gray-400" }, "STATE / ZIP CODE", -1)),
                    _createElementVNode("p", {
                      class: _normalizeClass(["text-sm font-semibold mt-0.5", valueClass(_ctx.employee.state || _ctx.employee.zip_code)])
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.employee.state || '') + " " + _toDisplayString(_ctx.employee.zip_code || '') + " ", 1),
                      (!_ctx.employee.state && !_ctx.employee.zip_code)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_38, "Not Provided"))
                        : _createCommentVNode("", true)
                    ], 2)
                  ])
                ])
              ])
            ], 512), [
              [_vShow, activeTab.value === 'contact']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _cache[21] || (_cache[21] = _createElementVNode("span", { class: "text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400" }, "Position / Job Title", -1)),
                  _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.employee.position || 'Not Assigned'), 1)
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _cache[22] || (_cache[22] = _createElementVNode("span", { class: "text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400" }, "Department", -1)),
                  _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.employee.department || 'Not Assigned'), 1)
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _cache[23] || (_cache[23] = _createElementVNode("span", { class: "text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400" }, "Date of Hire", -1)),
                  _createElementVNode("p", _hoisted_46, _toDisplayString(formatDate(_ctx.employee.hire_date)), 1)
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _cache[24] || (_cache[24] = _createElementVNode("span", { class: "text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400" }, "User Role", -1)),
                  _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.employee.user_type_label || 'Employee'), 1)
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _cache[25] || (_cache[25] = _createElementVNode("span", { class: "text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400" }, "Account Created", -1)),
                  _createElementVNode("p", _hoisted_50, _toDisplayString(formatDate(_ctx.employee.created_at)), 1)
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _cache[26] || (_cache[26] = _createElementVNode("span", { class: "text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400" }, "Account Status", -1)),
                  _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.employee.status), 1)
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _cache[27] || (_cache[27] = _createElementVNode("span", { class: "text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400" }, "Work State / Jurisdiction", -1)),
                  _createElementVNode("div", _hoisted_54, [
                    (_ctx.employee.work_state)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass(["inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-bold", [
                  _ctx.employee.work_state === 'Maryland'
                    ? 'bg-blue-100 text-blue-800 dark:bg-blue-900/60 dark:text-blue-300'
                    : _ctx.employee.work_state === 'DC'
                    ? 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/60 dark:text-emerald-300'
                    : 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/60 dark:text-indigo-300'
                ]])
                        }, _toDisplayString(_ctx.employee.work_state === 'Both' ? 'Both (Maryland & DC)' : _ctx.employee.work_state), 3))
                      : (_openBlock(), _createElementBlock("span", _hoisted_55, "Not Specified"))
                  ])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _cache[28] || (_cache[28] = _createElementVNode("span", { class: "text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400" }, "Client Group / Service Population", -1)),
                  _createElementVNode("div", _hoisted_57, [
                    (_ctx.employee.service_population)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass(["inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-bold", [
                  _ctx.employee.service_population === 'Adults'
                    ? 'bg-amber-100 text-amber-800 dark:bg-amber-900/60 dark:text-amber-300'
                    : _ctx.employee.service_population === 'Kids'
                    ? 'bg-pink-100 text-pink-800 dark:bg-pink-900/60 dark:text-pink-300'
                    : 'bg-teal-100 text-teal-800 dark:bg-teal-900/60 dark:text-teal-300'
                ]])
                        }, _toDisplayString(_ctx.employee.service_population === 'Both' ? 'Both (Adults & Kids)' : _ctx.employee.service_population), 3))
                      : (_openBlock(), _createElementBlock("span", _hoisted_58, "Not Specified"))
                  ])
                ])
              ])
            ], 512), [
              [_vShow, activeTab.value === 'employment']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _createVNode(_unref(AlertTriangle), { class: "w-5 h-5 text-amber-600 dark:text-amber-400" }),
                  _cache[29] || (_cache[29] = _createElementVNode("h4", { class: "text-base font-bold text-gray-900 dark:text-white" }, "Emergency Contact Information", -1))
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("div", _hoisted_63, [
                    _cache[30] || (_cache[30] = _createElementVNode("span", { class: "text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400" }, "Contact Person", -1)),
                    _createElementVNode("p", _hoisted_64, _toDisplayString(_ctx.employee.emergency_contact_name || 'Not Provided'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    _cache[31] || (_cache[31] = _createElementVNode("span", { class: "text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400" }, "Relationship", -1)),
                    _createElementVNode("p", _hoisted_66, _toDisplayString(_ctx.employee.emergency_contact_relation || 'Not Provided'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    _cache[32] || (_cache[32] = _createElementVNode("span", { class: "text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400" }, "Phone Number", -1)),
                    _createElementVNode("p", _hoisted_68, _toDisplayString(_ctx.employee.emergency_contact_phone || 'Not Provided'), 1)
                  ])
                ])
              ])
            ], 512), [
              [_vShow, activeTab.value === 'emergency']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_69, [
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _createVNode(_unref(Files), { class: "w-7 h-7" })
                ]),
                _cache[33] || (_cache[33] = _createElementVNode("div", null, [
                  _createElementVNode("h3", { class: "text-lg font-bold text-gray-900 dark:text-white" }, "Employee Documents & Credentials"),
                  _createElementVNode("p", { class: "text-sm text-gray-500 dark:text-gray-400 mt-1 max-w-md mx-auto" }, " Manage certifications, licenses, background checks, manual/paper application records, and credentials for this staff member. ")
                ], -1)),
                _createElementVNode("div", _hoisted_72, [
                  _createVNode(BaseButton, {
                    text: "Manage & View Documents",
                    variant: "primary",
                    icon: _unref(FolderOpen),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('manageDocuments', _ctx.employee)))
                  }, null, 8, ["icon"]),
                  _createVNode(BaseButton, {
                    text: "Upload New Document",
                    variant: "outline",
                    icon: _unref(UploadCloud),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('uploadDocuments', _ctx.employee)))
                  }, null, 8, ["icon"])
                ])
              ])
            ], 512), [
              [_vShow, activeTab.value === 'documents']
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["is-visible", "subtitle", "icon"]))
}
}

})